import React, { CSSProperties, FC, PropsWithChildren } from "react";

import classNames from "classnames";
import styles from "./Container.module.scss";

interface ContainerProps {
  className?: string;
  style?: CSSProperties;
}

const Container: FC<PropsWithChildren<ContainerProps>> = ({
  children,
  className,
  style,
}) => {
  return (
    <div style={style} className={classNames(styles.Container, className)}>
      {children}
    </div>
  );
};

export default Container;
